<template>
  <div v-if="infoData" class="form-container">
    <div style="margin-left: 150px">
      <el-tabs class="tfam-custom-tabs" v-model="currentLang">
        <el-tab-pane
          v-for="(lang) in langList"
          :key="lang['language_key']"
          :label="lang['title']"
          :name="lang['language_key']"></el-tab-pane>
      </el-tabs>
    </div>
    <el-form ref="form" :model="infoData" label-width="100px" label-position="left">
      <div class="from-group-container">
        <div class="form-group-title">
          <span>
            參觀資訊
          </span>
        </div>
        <div class="form-group-content">
          <el-form-item label="地點">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3 }"
              v-model="infoData[currentLang].info_location"
              maxlength="255"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="時間">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3 }"
              v-model="infoData[currentLang].info_open_time"
              maxlength="255"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="備註">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3 }"
              v-model="infoData[currentLang].info_comment"
              maxlength="255"
              show-word-limit
            ></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="from-group-container">
        <div class="form-group-title">
          <span>
            票價
          </span>
        </div>
        <div class="form-group-content">
          <el-form-item label="票種">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3 }"
              v-model="infoData[currentLang].ticket_type"
              maxlength="255"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="備註">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3 }"
              v-model="infoData[currentLang].ticket_comment"
              maxlength="255"
              show-word-limit
            ></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="from-group-container">
        <div class="form-group-title">
          <span>
            導覽一
          </span>
        </div>
        <div class="form-group-content">
          <el-form-item label="標題">
            <el-input
              v-model="infoData[currentLang].exhibition_title_1"
              maxlength="255"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="連結">
            <el-input
              v-model="infoData[currentLang].exhibition_value_1"
              maxlength="255"
              show-word-limit
            ></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="from-group-container">
        <div class="form-group-title">
          <span>
            導覽二
          </span>
        </div>
        <div class="form-group-content">
          <el-form-item label="標題">
            <el-input
              v-model="infoData[currentLang].exhibition_title_2"
              maxlength="255"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="連結">
            <el-input
              v-model="infoData[currentLang].exhibition_value_2"
              maxlength="255"
              show-word-limit
            ></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="from-group-container">
        <div class="form-group-title">
          <span>
            導覽三
          </span>
        </div>
        <div class="form-group-content">
          <el-form-item label="標題">
            <el-input
              v-model="infoData[currentLang].exhibition_title_3"
              maxlength="255"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="連結">
            <el-input
              v-model="infoData[currentLang].exhibition_value_3"
              maxlength="255"
              show-word-limit
            ></el-input>
          </el-form-item>
        </div>
      </div>
      <el-form-item label-width="150px">
        <el-button class="tfam-button" plain v-loading.fullscreen.lock="fullLoading" @click="handleSubmit">更新並儲存</el-button>
        <el-button class="tfam-button" plain>返回至上一層</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {fetchTFAMInfoList, createTFAMInfo, updateTFAMInfo} from "../../api/tfamInfo";

export default {
  name: "InfoEdit",
  data() {
    return {
      currentLang: 'ZH_TW',
      langList: this.$store.getters.langList,
      infoData: undefined,
      infoList: [],
      fullLoading: true
    }
  },
  methods: {
    getList() {
      this.fullLoading = true
      fetchTFAMInfoList().then(res => {
        this.fullLoading = false
        console.log(res)
        console.log(this.langList)
        const dataList = res.data
        const infoData = {}
        for (const i in this.langList) {
          const lang = this.langList[i]['language_key']
          const filter = dataList.filter(x => x['language_key'] === lang)
          if (filter.length > 0) {
            infoData[lang] = filter[0]
          } else {
            infoData[lang] = {
              "language_key": lang,
              "info_location": "",
              "info_open_time": "",
              "info_comment": "",
              "ticket_type": "",
              "ticket_comment": "",
              "exhibition_title_1": "",
              "exhibition_value_1": "",
              "exhibition_title_2": "",
              "exhibition_value_2": "",
              "exhibition_title_3": "",
              "exhibition_value_3": "",
              "update_at": new Date()
            }
          }
        }
        this.infoData = infoData
      }).catch(e => {
        console.log(err);
        let message = err;
        if (err.response) {
          message = err.response.data.error.message + '!'
        }
        this.$alert(message, '系統問題', {
          confirmButtonText: '確定',
          callback: action => {
          }
        });
        this.fullLoading = false;
      })
    },
    handleSubmit() {
      const dataList = []
      for (const i in this.langList) {
        const lang = this.langList[i]['language_key']
        dataList.push(JSON.parse(JSON.stringify(this.infoData[lang])))
      }
      this.fullLoading = true
      this.asyncSubmit(dataList).then(res => {
        this.fullLoading = false
        this.$message({
          type: 'success',
          message: '儲存成功!'
        });
        this.getList()
      }).catch(err => {
        console.log(err);
        let message = err;
        if (err.response) {
          message = err.response.data.error.message + '!'
        }
        this.$alert(message, '儲存失敗', {
          confirmButtonText: '確定',
          callback: action => {
          }
        });
        this.fullLoading = false;
      })
    },
    async asyncSubmit(dataList) {
      try {
        for (const i in dataList) {
          const data = dataList[i]
          data['update_at'] = new Date()
          if (data['tfam_info_id']) {
            const updateData = JSON.parse(JSON.stringify(data))
            delete updateData['tfam_info_id']
            await updateTFAMInfo(data['tfam_info_id'], updateData)
          } else {
            await createTFAMInfo(data)
          }
        }
        return Promise.resolve(true)
      } catch (e) {
        return Promise.reject(e)
      }
    }
  },
  mounted() {
    this.getList()
  }
}
</script>

<style lang="scss">
.room-options {
  width: 100%;
}

.el-select {
  width: 100%;
}

.text-content {
  width: 100%;
  min-height: 40px;
  /*height: 70px;*/
  padding: 0 20px;
  background-color: white;
  /*margin: 10px 0;*/
  span {
    font-size: 14px;
    line-height: 40px;
    color: #222;
  }
}

.el-select-dropdown {
  width: 500px !important;
}

.from-group-container {
  display: flex;
  .form-group-title {
    width: 40px;
    text-align: center;
    position: relative;
    font-size: 20px;
    font-weight: bolder;
    border-right: 5px solid darkgray;
    margin: 0 10px 22px 0;
    span {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      writing-mode: vertical-lr;
      letter-spacing: 15px
    }
  }
  .form-group-content {
    width: 100%;
  }
}
</style>
